import keys from 'constants/keys'
import { IAiPromptDraft } from 'components/TasksV2/AITaskCreation/model/subtaskDraft'

/** Preserve the source subtask's metadata; AI only replaces its generated title/instructions/references. */
export function mergeAiSubtask(subtask: any, generated: any, prompt: IAiPromptDraft) {
  const images = generated.content?.images ?? prompt.reference_images ?? []
  return {
    ...subtask,
    title: generated.title || subtask.title,
    content: { ...(subtask.content ?? {}), rich_text: generated.content?.rich_text ?? null, images },
    is_ai_enhanced: true,
    prompt_id: keys.AI_IMAGE_SUBTASK.CONST_PROMPT_ID,
    reference_images: images,
    ai_prompt: prompt.prompt ?? '',
  }
}
